import { buildInFilter, mergeFilters } from './gridFilters';
import type { GridQueryInput } from './gridUtils';
import type { QueryResult } from '@flowqa/shared';

export const emptyQueryResult = <T>(input: GridQueryInput): QueryResult<T> => ({
  items: [],
  total: 0,
  page: input.page,
  pageSize: input.pageSize,
});

export const buildIdsQueryFn = <T>(
  ids: Array<string | null | undefined>,
  fetch: (input: GridQueryInput) => Promise<QueryResult<T>>,
): ((input: GridQueryInput) => Promise<QueryResult<T>>) => {
  const normalizedIds = ids.filter((id): id is string => typeof id === 'string' && id.length > 0);
  if (normalizedIds.length === 0) {
    return async (input) => Promise.resolve(emptyQueryResult(input));
  }
  return async (input) => {
    const filters = mergeFilters(input.filters, buildInFilter('id', normalizedIds));
    return await fetch({ ...input, filters });
  };
};
